import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const Dashboard = createSvgIcon(
  <svg viewBox="0 0 48 48" x="0px" y="0px" version="1.1">
    <g id="dashboard">
      <g id="Group-2" transform="translate(2 2)">
        <g id="Rectangle-Copy-6">
          <path d="M 44 4.9 H 0 V 0 h 44 V 4.9 Z M 0.5 4.4 h 43 V 0.5 h -43 V 4.4 Z" />
        </g>
        <g id="Rectangle-Copy-7">
          <path d="M 19.6 24.4 H 0 V 9.8 h 19.6 V 24.4 Z M 0.5 23.9 h 18.6 V 10.3 H 0.5 V 23.9 Z" />
        </g>
        <g id="Rectangle-Copy-16">
          <path d="M 19.6 44 H 0 V 29.3 h 19.6 V 44 Z M 0.5 43.5 h 18.6 V 29.8 H 0.5 V 43.5 Z" />
        </g>
        <g id="Rectangle-Copy-8">
          <path d="M 44 24.4 H 24.4 V 9.8 H 44 V 24.4 Z M 24.9 23.9 h 18.6 V 10.3 H 24.9 V 23.9 Z" />
        </g>
        <g id="Rectangle-Copy-10">
          <path d="M 44 44 H 24.4 V 29.3 H 44 V 44 Z M 24.9 43.5 h 18.6 V 29.8 H 24.9 V 43.5 Z" />
        </g>
      </g>
    </g>
  </svg>,
  'Dashboard'
);
